import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message, Space, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { collaboratorAPI } from '../services/api';

const CollaboratorManagement = () => {
  const [collaborators, setCollaborators] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchCollaborators();
  }, []);

  const fetchCollaborators = async () => {
    setLoading(true);
    try {
      const response = await collaboratorAPI.getAll();
      setCollaborators(response.data);
    } catch (error) {
      message.error('Lỗi khi tải danh sách cộng tác viên');
    }
    setLoading(false);
  };

  const handleSubmit = async (values) => {
    try {
      if (editingId) {
        await collaboratorAPI.update(editingId, values);
        message.success('Cập nhật thành công');
      } else {
        await collaboratorAPI.create(values);
        message.success('Tạo cộng tác viên thành công');
      }
      setModalVisible(false);
      setEditingId(null);
      form.resetFields();
      fetchCollaborators();
    } catch (error) {
      message.error('Lỗi khi lưu dữ liệu');
    }
  };

  const handleEdit = (record) => {
    setEditingId(record._id);
    form.setFieldsValue({ tele: record.tele });
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await collaboratorAPI.delete(id);
      message.success('Xóa thành công');
      fetchCollaborators();
    } catch (error) {
      message.error('Lỗi khi xóa');
    }
  };

  const columns = [
    { title: 'Telegram', dataIndex: 'tele', key: 'tele' },
    { 
      title: 'Tổng nạp', 
      dataIndex: 'totalDeposit', 
      key: 'totalDeposit', 
      render: (val) => `$${val?.toLocaleString()}` 
    },
    { 
      title: 'Số dư', 
      dataIndex: 'funds', 
      key: 'funds', 
      render: (val) => (
        <span style={{ color: val > 0 ? 'green' : val < 0 ? 'red' : 'black' }}>
          ${val?.toLocaleString()}
        </span>
      )
    },
    {
      title: 'Hành động',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button type="link" icon={<EditOutlined />} onClick={() => handleEdit(record)} />
          <Button type="link" href={`/collaborators/${record._id}`}>Chi tiết</Button>
          <Popconfirm title="Xác nhận xóa?" onConfirm={() => handleDelete(record._id)}>
            <Button type="link" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div style={{ padding: 24 }}>
      <h1>Quản lý Cộng tác viên</h1>
      <Button type="primary" icon={<PlusOutlined />} onClick={() => setModalVisible(true)} style={{ marginBottom: 16 }}>
        Thêm Cộng tác viên
      </Button>
      
      <Table columns={columns} dataSource={collaborators} loading={loading} rowKey="_id" />

      <Modal
        title={editingId ? 'Chỉnh sửa Cộng tác viên' : 'Thêm Cộng tác viên'}
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          setEditingId(null);
          form.resetFields();
        }}
        footer={null}
      >
        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <Form.Item name="tele" label="Telegram" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Button type="primary" htmlType="submit" block>
            {editingId ? 'Cập nhật' : 'Tạo'}
          </Button>
        </Form>
      </Modal>
    </div>
  );
};

export default CollaboratorManagement;
